<!-- components/IdleWarningDialog.vue -->
<template>
  <div v-if="visible" class="idle-warning-overlay">
    <div class="idle-warning-dialog">
      <h3>Session Expiring Soon</h3>
      <p>You have been inactive for a long time. The system will automatically log you out in <strong>{{ remainingSeconds }}</strong> seconds.</p>
      <p>Click the button below if you want to continue using the application.</p>
      <div class="dialog-buttons">
        <v-btn
          dark
          class="btn-continue"
          :loading="continuing"
          :disabled="continuing"
          @click="handleContinue"
        >
          Continue Session
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IdleWarningDialog',
  data() {
    return {
      visible: false,
      remainingSeconds: 0,
      continuing: false,
      onContinue: null,
    }
  },
  methods: {
    show(seconds, callbacks) {
      this.remainingSeconds = seconds
      this.onContinue = callbacks.continue
      this.continuing = false
      this.visible = true
    },
    async handleContinue() {
      if (this.continuing || !this.onContinue) return
      this.continuing = true
      try {
        await this.onContinue()
        this.visible = false
      } catch (e) {
        console.error('Continue session failed', e)
      } finally {
        this.continuing = false
      }
    },
    hide() {
      this.visible = false
      this.continuing = false
    },
  },
}
</script>

<style scoped>
.idle-warning-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.idle-warning-dialog {
  background: white;
  border-radius: 8px;
  padding: 24px;
  width: 600px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.idle-warning-dialog h3 {
  margin: 0 0 16px 0;
  color: #f56c6c;
}

.idle-warning-dialog p {
  margin: 12px 0;
  line-height: 1.5;
}

.dialog-buttons {
  margin-top: 24px;
  text-align: center;
}

.btn-continue {
  background-color: #409eff;
  color: white;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.btn-continue:hover {
  background-color: #66b1ff;
}
</style>
